import ApiRequest from '@/core/ApiRequest'
import AccessModel from '@/core/models/AccessModel'
import UserModel from '@/core/models/User'
import RoomModel from '@/core/models/Room'
import { MenuGroup } from '@/core/models/Menu'

/**
 * Root Vuex state.
 */
export default class RootState {
  /**
   * Is search results loading state.
   */
  public isLoading: boolean = false

  /**
   * Is user dialog shown state.
   */
  public isUserDialogShown: boolean = false

  /**
   * Is menu dialog shown state.
   */
  public isMenuDialogShown: boolean = false

  /**
   * Is history dialog shown state.
   */
  public isHistoryDialogShown: boolean = false

  /**
   * State of application roomsList.
   */
  public roomsList: RoomModel[] = []

  /**
   * State of application usersList.
   */
  public usersList: UserModel[] = []

  /**
   * State of application menuList.
   */
  public menuList: MenuGroup[] = []

  /**
   * State of application accessModel.
   */
  public accessModel: AccessModel | null

  /**
   * State of application apiRequest.
   */
  public apiRequest: ApiRequest | null

  /**
   * State of calendar last date.
   */
  public calendarLastDate: String | null

  /**
   * State of clients last search query.
   */
  public clientLastSearchQuery: string = ''

  /**
   * Creates initial root store state.
   */
  constructor () {
    this.roomsList = []
    this.usersList = []
    this.menuList = []
    this.accessModel = null
    this.apiRequest = null
    this.isUserDialogShown = false
    this.isMenuDialogShown = false
    this.isHistoryDialogShown = false
    this.calendarLastDate = null
    this.clientLastSearchQuery = ''
  }
}
